import http from '@/fetch/http'
import * as types  from '@/vuex/types'
import util from '@/utils'
import Vue from 'vue'

const state = {
   //当前试题index
  exerciseIndex:0,
  //点击每个空的type
  showType:-1,
  //点击每个空是否显示未作答人数
  showUndoNum:true
}

const actions = {
  setExerciseIndex({commit}, param){
    commit('SET_EXERCISE_INDEX', param);
  },
  setShowType({commit}, param){
    commit('SET_SHOWTYPE', param);
    if(param==10|| param==11){
      state.showUndoNum=false;
    }else{
      state.showUndoNum=true;
    }
  }
}

const mutations = {
  ['SET_EXERCISE_INDEX'](state, exerciseIndex) {
    Vue.set(state, 'exerciseIndex', exerciseIndex);
  },
  ['SET_SHOWTYPE'](state, showType) {
    Vue.set(state, 'showType', showType);
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/practiceAnalysis.js